module.exports = "/public/images/b72af624258da51551fe4fa545bd1054.png";